export default __webpack_public_path__ + "static/media/login-background.dd8fe559.jpg";